/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim4DiagMaxIcon32Regular = forwardRef('ArrowDim4DiagMaxIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M6 3a3 3 0 0 0-3 3v6a1 1 0 1 0 2 0V6.414l7.293 7.293a1 1 0 1 0 1.414-1.414L6.414 5H12a1 1 0 1 0 0-2H6Z" }),
        React.createElement("path", { d: "M19 4a1 1 0 0 1 1-1h6a3 3 0 0 1 3 3v6a1 1 0 1 1-2 0V6.414l-7.293 7.293a1 1 0 0 1-1.414-1.414L25.586 5H20a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M19.707 18.293a1 1 0 0 0-1.414 1.414L25.586 27H20a1 1 0 1 0 0 2h6a3 3 0 0 0 3-3v-6a1 1 0 1 0-2 0v5.586l-7.293-7.293Z" }),
        React.createElement("path", { d: "M13.708 19.707a1 1 0 0 0-1.415-1.414L5 25.586V20a1 1 0 1 0-2 0v6a3 3 0 0 0 3 3h6a1 1 0 1 0 0-2H6.414l7.294-7.293Z" })));
});
